export default (imgSrc) => Boolean(imgSrc && /^data:image/.test(imgSrc));
